import { put, call, takeLatest, all, select } from 'redux-saga/effects';
import { lessonOverviewActionTypes } from './Constants';
import { processTutoringRequest } from '../../shared/Constants';
import { overviewData } from './Selectors';
import * as lessonActions from './Actions';
import * as errorHandlerActions from '../../../components/errorHandler/Actions';

export default function* () {
	yield all([
		takeLatest(
			lessonOverviewActionTypes.GET_LESSON_OVERVIEW_REQUEST,
			handleLessonOverviewRequest,
		),
		takeLatest(
			lessonOverviewActionTypes.GET_MY_SCHEDULED_LESSONS_REQUEST,
			handleMyScheduledLessonsRequest,
		),
		takeLatest(
			lessonOverviewActionTypes.GET_RECOMMENDED_LESSONS_REQUEST,
			handleRecommendedLessonsRequest,
		),
	]);
}

export function* handleLessonOverviewRequest({ payload }) {
	try {
		const { queries = {} } = payload || {};

		const { data } = yield call(processTutoringRequest, 'public/lessons', 'GET', queries);

		const formattedData = { ...data };

		if (queries?.offset) {
			const overview = yield select(overviewData);
			formattedData.results = [...overview.results, ...formattedData.results];
		}
		yield put(
			lessonActions.getLessonOverviewSuccess({ ...formattedData, no_index: data.no_index }),
		);
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(lessonActions.getLessonOverviewError());
	}
}

export function* handleMyScheduledLessonsRequest({ payload }) {
	try {
		const { userId } = payload || {};

		const { data } = yield call(
			processTutoringRequest,
			`users/${userId}/scheduled_lessons`,
			'GET',
		);

		yield put(lessonActions.getMyScheduledLessonsSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(lessonActions.getMyScheduledLessonsError());
	}
}

export function* handleRecommendedLessonsRequest({ payload }) {
	try {
		const { queries: userId } = payload || {};

		const { data } = yield call(
			processTutoringRequest,
			`users/${userId}/recommended_lessons`,
			'GET',
		);

		yield put(lessonActions.getRecommendedLessonsSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(lessonActions.getRecommendedLessonsError());
	}
}
